import { connect } from 'react-redux';
import { FILL } from '../../../../../../redux/actions/app/fill/fill.actions';
import { getLoadingEntity } from '../../../../../../redux/selectors/ui/ui.selectors';
import { getUrlPDFDocumentInformationTarif } from '../../../../../../redux/selectors/tarif/tarif.selectors';
import Souscrire from './Souscrire';

const mapStateToProps = (state) => {
    return {
        loading: getLoadingEntity(state, FILL),
        urlDocumentInformation: getUrlPDFDocumentInformationTarif(state),
    };
};

const SouscrireContainer = connect(mapStateToProps)(Souscrire);

export default SouscrireContainer;
